import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function ComplianceCenter() {
	return (
		<>
			<Helmet>
				<title>Compliance Center | A-Z Home Improvement LLC</title>
				<meta name="description" content="A-Z Home Improvement LLC compliance information — AZ ROC licensing, insurance, SMS program details, and TCPA compliance." />
			</Helmet>
			<PageHeader
				title="Compliance Center"
				subtitle="Licensing, insurance, SMS program, and regulatory compliance information for A-Z Home Improvement LLC."
			/>

			<section className="section">
				<div className="container" style={{ maxWidth: 820 }}>

					{/* Licensing */}
					<div className="card" style={{ padding: 28, marginBottom: 24 }}>
						<h2 style={{ marginTop: 0 }}>Contractor Licensing</h2>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
							<tbody>
								{[
									['State', 'Arizona'],
									['License Type', 'Residential &amp; Commercial General Contractor'],
									['License Number', 'AZ ROC #XXXXX8142'],
									['Issuing Authority', 'Arizona Registrar of Contractors (ROC)'],
									['Verification URL', 'roc.az.gov'],
									['License Status', 'Active'],
									['Business Entity', 'A-Z Home Improvement LLC'],
									['Legal State', 'Arizona'],
								].map(([k, v]) => (
									<tr key={k} style={{ borderBottom: '1px solid #eee' }}>
										<td style={{ padding: '9px 12px', fontWeight: 600, width: '40%', color: '#555' }} dangerouslySetInnerHTML={{ __html: k }} />
										<td style={{ padding: '9px 12px' }} dangerouslySetInnerHTML={{ __html: v }} />
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* Insurance */}
					<div className="card" style={{ padding: 28, marginBottom: 24 }}>
						<h2 style={{ marginTop: 0 }}>Insurance Coverage</h2>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
							<tbody>
								{[
									['General Liability', '$2,000,000 per occurrence / $4,000,000 aggregate'],
									['Workers\' Compensation', 'Active — all employees and subcontractors'],
									['Certificate Available', 'Yes — provided upon request before project start'],
									['Coverage Area', 'Arizona statewide'],
								].map(([k, v]) => (
									<tr key={k} style={{ borderBottom: '1px solid #eee' }}>
										<td style={{ padding: '9px 12px', fontWeight: 600, width: '40%', color: '#555' }}>{k}</td>
										<td style={{ padding: '9px 12px' }}>{v}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* SMS Compliance */}
					<div className="card" style={{ padding: 28, marginBottom: 24 }}>
						<h2 style={{ marginTop: 0 }}>SMS/Text Message Program</h2>
						<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
							<tbody>
								{[
									['Program Name', 'A-Z Home Improvement LLC SMS Alerts &amp; Marketing'],
									['Message Types', 'Estimate confirmations, reminders, project updates, promotions'],
									['Opt-In Method', 'Website form checkbox with explicit dual consent disclosure'],
									['Opt-Out Method', 'Reply STOP · Email support@azhomefundingservices.com · Online form at /opt-out'],
									['Help Command', 'Reply HELP to any message'],
									['Message Frequency', 'Up to 6/week during active project; 2–4/month otherwise'],
									['Data Sharing', 'No mobile data shared with third parties for marketing'],
									['Governing Framework', 'TCPA (47 U.S.C. § 227), FCC TCPA Rules, CTIA Guidelines'],
								].map(([k, v]) => (
									<tr key={k} style={{ borderBottom: '1px solid #eee' }}>
										<td style={{ padding: '9px 12px', fontWeight: 600, width: '40%', color: '#555' }} dangerouslySetInnerHTML={{ __html: k }} />
										<td style={{ padding: '9px 12px' }} dangerouslySetInnerHTML={{ __html: v }} />
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{/* Consumer Rights */}
					<div className="card" style={{ padding: 28, marginBottom: 24 }}>
						<h2 style={{ marginTop: 0 }}>Consumer Rights</h2>
						<ul style={{ margin: 0 }}>
							<li><strong>Right to opt out:</strong> Reply STOP at any time to stop receiving SMS messages from us.</li>
							<li><strong>Right to access:</strong> Request a copy of data we hold about you by emailing support@azhomefundingservices.com.</li>
							<li><strong>Right to delete:</strong> Request deletion of your personal data by contacting us in writing.</li>
							<li><strong>Right to complain:</strong> Contact the FCC at fcc.gov/consumers, the Arizona Attorney General at azag.gov, or the BBB at bbb.org.</li>
						</ul>
					</div>

					{/* Contact */}
					<div className="card" style={{ padding: 28 }}>
						<h2 style={{ marginTop: 0 }}>Compliance Contact</h2>
						<address style={{ fontStyle: 'normal' }}>
							<strong>A-Z Home Improvement LLC</strong><br />
							3842 W. McDowell Rd, Suite 110<br />
							Phoenix, AZ 85009<br />
							Phone: <a href="tel:+16023902536" style={{ color: 'var(--brand)' }}>(602) 390-2536</a><br />
							Email: <a href="mailto:support@azhomefundingservices.com" style={{ color: 'var(--brand)' }}>support@azhomefundingservices.com</a>
						</address>
					</div>

				</div>
			</section>
		</>
	);
}

export default ComplianceCenter;
